import { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { X, Search, Save, Trash2, Loader2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export const AbbinaImmagineModal = ({ vino, onClose, onSaved, getAuthHeaders }) => {
  const [url, setUrl] = useState(vino?.immagine_url || '');
  const [candidati, setCandidati] = useState([]);
  const [cercando, setCercando] = useState(false);
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    setUrl(vino?.immagine_url || '');
    setCandidati([]);
  }, [vino]);

  if (!vino) return null;

  const cerca = async () => {
    setCercando(true);
    try {
      const q = encodeURIComponent(`${vino.cantina || ''} ${vino.nome}`.trim());
      const r = await axios.get(`${API}/api/carta-vini/cerca-immagine?q=${q}`, { headers: getAuthHeaders(), timeout: 25000 });
      setCandidati(r.data.risultati || []);
      if ((r.data.risultati || []).length === 0) toast.info('Nessuna immagine trovata: incolla un link manualmente');
    } catch (e) {
      toast.error('Ricerca immagini non riuscita');
    }
    setCercando(false);
  };

  const salva = async (valore) => {
    setSalvando(true);
    try {
      await axios.post(`${API}/api/magazzino/vini/aggiorna`, { vino_id: vino.id, immagine_url: valore }, { headers: getAuthHeaders() });
      toast.success(valore ? 'Immagine abbinata' : 'Immagine rimossa');
      onSaved && onSaved(vino.id, valore);
      onClose();
    } catch (e) {
      toast.error('Errore salvataggio immagine');
    }
    setSalvando(false);
  };

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4" data-testid="abbina-immagine-modal">
      <div className="bg-white rounded-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between p-4 border-b sticky top-0 bg-white rounded-t-2xl">
          <h3 className="font-bold text-sm pr-2">🍾 Immagine per: {vino.nome}</h3>
          <button onClick={onClose} data-testid="abbina-modal-close" className="p-1.5 hover:bg-gray-100 rounded-lg"><X className="h-5 w-5" /></button>
        </div>
        <div className="p-5 space-y-4">
          {/* Anteprima corrente */}
          <div className="flex items-center gap-4">
            <div className="w-16 h-24 border rounded-lg flex items-center justify-center bg-gray-50 overflow-hidden">
              {url ? <img src={url} alt="" className="max-w-full max-h-full object-contain" /> : <span className="text-2xl opacity-30">🍾</span>}
            </div>
            <div className="flex-1">
              <label className="text-xs text-gray-600 font-medium">Link immagine (URL)</label>
              <input value={url} onChange={e => setUrl(e.target.value)} placeholder="https://..." data-testid="immagine-url-input"
                className="w-full border rounded-lg px-3 py-2 text-sm mt-1" />
            </div>
          </div>

          <div className="flex gap-2">
            <button onClick={cerca} disabled={cercando} data-testid="cerca-immagine-btn"
              className="flex-1 py-2 bg-blue-600 text-white rounded-lg text-sm flex items-center justify-center gap-2 disabled:opacity-50">
              {cercando ? <Loader2 className="h-4 w-4 animate-spin" /> : <Search className="h-4 w-4" />} Cerca automaticamente
            </button>
            <button onClick={() => salva(url)} disabled={salvando || !url} data-testid="salva-immagine-btn"
              className="flex-1 py-2 bg-green-600 text-white rounded-lg text-sm flex items-center justify-center gap-2 disabled:opacity-50">
              <Save className="h-4 w-4" /> Salva
            </button>
            {vino.immagine_url && (
              <button onClick={() => salva('')} disabled={salvando} data-testid="rimuovi-immagine-btn"
                className="py-2 px-3 bg-red-100 text-red-600 rounded-lg text-sm" title="Rimuovi immagine">
                <Trash2 className="h-4 w-4" />
              </button>
            )}
          </div>

          {/* Candidati trovati */}
          {candidati.length > 0 && (
            <div>
              <p className="text-xs text-gray-600 font-medium mb-2">Tocca un'immagine per selezionarla:</p>
              <div className="grid grid-cols-4 gap-2">
                {candidati.map((c, i) => (
                  <button key={i} onClick={() => setUrl(c.url)} data-testid={`candidato-img-${i}`}
                    className={`border-2 rounded-lg overflow-hidden h-24 bg-gray-50 ${url === c.url ? 'border-purple-600' : 'border-gray-200'}`}>
                    <img src={c.thumbnail} alt={c.titolo} className="w-full h-full object-contain" />
                  </button>
                ))}
              </div>
            </div>
          )}
          <p className="text-[11px] text-gray-400">Suggerimento: puoi incollare il link di una foto dal sito della cantina o caricare la foto su un servizio e incollare qui il link.</p>
        </div>
      </div>
    </div>
  );
};
